import { Component } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { MCategoryResponseModal } from '../blog/blog.module';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.scss']
})
export class BlogListComponent {
  mCategoryResponseModal: MCategoryResponseModal = new MCategoryResponseModal()
  trendingBlogs: any = [];
  allTrendingBlogsCategoryWise: any = [];
  share: any;
  baseUrl: any = window.location.origin;
  currentUrl: any;
  constructor(private _commonBehaviorChangeService:CommonBehaviorChangeService ,private wsblogservice: WsBlogService, private router: Router, private toast: ToastrService){}

  ngOnInit(){
    this.getCategoryList();
    this.getTrendingBlogList();
    document.body.addEventListener('click', this.toggleShareBox.bind(this));
  }

    /**
   * Hide Share Box on outside click
   * @param event 
   */
    toggleShareBox(event: Event): void {
      const isInsideBlogIcon = (event.target as HTMLElement).closest('.blog-icon');
      if (!isInsideBlogIcon) {
        this.share = null; // Hides the share box when clicked outside
      }
    }

  ngOnDestroy() {
    document.body.removeEventListener('click', this.toggleShareBox.bind(this));
  }

  async getCategoryList() {
    const categoryListData = this.wsblogservice.getCategoryByType(2);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
      } else {
      }
    })
  }

  async openBlogList(categoryId: any) {
    this.router.navigate(["/blog-list/" + categoryId])
  }

  async getTrendingBlogList() {
    this.trendingBlogs = [];
    const trendingBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(true);
    await lastValueFrom(trendingBlogs).then(response => {
      if (response && response.statusCode == 200 && response.data) {
        this.allTrendingBlogsCategoryWise = response.data;
        response.data.forEach((blog:any) => {
          if(this.trendingBlogs.length < 1){
            this.trendingBlogs = blog.blogs;
          }else{
            this.trendingBlogs = [...this.trendingBlogs , ...blog.blogs];
          }
        })
      }
    })
  }

  getBlogThumbnail(imageList: any) {
    if (imageList.length < 1) {
      return 'assets/images/noblogimage.jpg'
    }
    var thumbnail = imageList.filter((img: any) => img.type == 'blog_thumbnail_image')
    if (thumbnail.length > 0) {
      return thumbnail[0].path;
    }
    else {
      return 'assets/images/noblogimage.jpg'
    }
  }

  async openBlogDetail(val: any) {
    this.router.navigate(["/individual-blog-updated/"+val.title.split(' ').join('_')+'/'+val.category_id+'/'+val.id])
  }

  showShare(hide?: any){
    if(hide == 'hide'){
      this.share = null;
    }
    else{
      if(this.share == hide.id){
        this.share = null;
      }
      else{
        this.share = hide.id;
        this.currentUrl = decodeURI(this.baseUrl+"/individual-blog-updated/"+hide.title.split(' ').join('_')+'/'+hide.category_id+'/'+hide.id)
      }
    }
  }


 clickToCopy(copy: any){

    const blogData = this.baseUrl+"/individual-blog-updated/"+copy.title.split(' ').join('_')+'/'+copy.category_id+'/'+copy.id;

    // Create a dummy textarea element to perform the copying
    const textarea = document.createElement('textarea');
    textarea.value = blogData;
    document.body.appendChild(textarea);
    
    // Select the text in the textarea
    textarea.select();
    document.execCommand('copy');
    
    // Clean up - remove the textarea
    document.body.removeChild(textarea);
    this._commonBehaviorChangeService.getToast('Blog Link Copied');

    this.showShare('hide');
  }
}